<template>
  <main class="main community" role="main">
    <div class="main_con" id="main_con">
      <!-- 검색 구역 -->
      <SectionSearch
        :total-cnt="knowhowCnt"
        @update="fnUpdate"
        ref="sectionSearch"
      />

      <!-- 게시판 리스트 -->
      <div class="con">
        <ul v-if="list.length > 0">
          <li
            class="list_item pnt"
            v-for="item in list"
            :key="item.id"
            @click="goDetail(item.id, item.reportCount)"
          >
            <ListItem :board-type="boardType" :data="item" />
          </li>
        </ul>
        <ul v-else>
          <div class="empty_wrap">
            <div class="empty">
              <div class="msg">
                <div>등록된 글이 없습니다</div>
              </div>
            </div>
          </div>
        </ul>
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>

      <!-- 질문하기 작성 버튼-->
      <button class="write_btn" @click="fnWrite">
        <i class="i_review_write_w"></i>
        <p>질문하기</p>
      </button>
    </div>
  </main>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import {
  mapActions as communityMapActions,
  mapGetters as communityGetters,
} from '@common/store/modules/community';
import * as communityTypes from '@common/store/modules/community/types';

import SectionSearch from '@common/components/community/SectionSearch';
import ListItem from '@common/components/community/ListItem';

export default {
  name: 'community-knowhow-list',
  description: '커뮤니티 > 사용자 지식인 리스트',
  components: {
    SectionSearch,
    ListItem,
    InfiniteLoading,
  },
  data() {
    return {
      boardType: 'KNOWHOW',
      params: {
        page: 1,
        size: 10,
        myPost: 'N',
        category: '',
        keyword: '',
        orderType: 'CREATED_AT_DESC',
        orderTypeLabel: '최신 순',
      },
      direction: 'top',
      infiniteId: 0,
      list: [],
      visitPage: 0, // 페이지 이동시 현재 페이지
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: ['Knowhow.Detail'], // 뒤로 이동시 가능한 방문 페이지 정리
    };
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  async mounted() {
    // 페이징 뒤로가기 설정 시작
    this.getPageList();
    // 페이징 뒤로가기 설정 끝
  },
  created() {
    this.params.keyword = this.$route.query.keyword;
    // this.getList();
  },
  computed: {
    ...communityGetters({
      knowhowList: communityTypes.FETCH_KNOWHOW_LIST,
      knowhowCnt: communityTypes.FETCH_KNOWHOW_CNT,
    }),
  },
  watch: {
    '$route.query.keyword'(val) {
      if (val) {
        this.params.keyword = val;
        this.params.page = 1;
        this.infiniteId = 0;
      }
    },
  },
  methods: {
    ...communityMapActions([communityTypes.FETCH_KNOWHOW_LIST]),
    // 페이징 뒤로가기 설정 시작
    getPageList() {
      this.params.page = 1;
      if (this.visitPage > 0) {
        for (var i = 0; i < this.visitPage - 1; i++) {
          this.infiniteId += 1;
        }
      } else {
        this.infiniteId += 1; //리스트 가져오기.
      }
    },
    // 페이징 뒤로가기 설정 끝
    async getknowhowList() {
      await this[communityTypes.FETCH_KNOWHOW_LIST](this.params);
      console.log('this.knowhowList');
      console.log(this.knowhowList);
    },
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_community_knowhow_list',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          console.log('visit_page GET');
          console.log(visit_page);
          this.visitPage = visit_page.params.page;
          this.params = visit_page.params;
          this.scrollLocation = visit_page.scrollLocation;

          this.$refs.sectionSearch.params.searchText =
            visit_page.params.keyword;
          this.$refs.sectionSearch.params.selectedFilter =
            visit_page.params.category;
          this.$refs.sectionSearch.params.selectedSort.value =
            visit_page.params.orderType;
          this.$refs.sectionSearch.params.selectedSort.label =
            visit_page.params.orderTypeLabel;
        }

        // 데이터 담고 삭제
        await localStorage.removeItem('visit_community_knowhow_list');

        this.getPageList();
      }
    },
    goDetail(boardId, reportCount) {
      if (reportCount == 0) {
        const target = document.querySelector('#main_con');
        // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
        let scrollLocation = target.scrollTop; // 현재 스크롤바 위치
        const visit_page = {
          params: this.params,
          scrollLocation: scrollLocation,
        };

        console.log('visit_page SET');
        console.log(visit_page);

        localStorage.setItem(
          'visit_community_knowhow_list',
          JSON.stringify(visit_page),
        );

        this.$router.push({
          name: 'Knowhow.Detail',
          params: { id: boardId, isRead: 'Y' },
        });
      }
    },
    fnWrite() {
      this.$router.push({ name: 'Knowhow.Write' });
    },
    fnUpdate(data) {
      this.params = {
        keyword: data.searchText,
        category: data.selectedFilter,
        orderType: data.selectedSort.value,
        orderTypeLabel: data.selectedSort.label,
        page: 1,
      };
      this.scrollLocation = 0;
      this.getListPageOne();
    },
    async getListPageOne() {
      this.list = [];
      this.direction = 'top';
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      const target = document.querySelector('#main_con');
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getknowhowList();

        if (this.params.page == 1) {
          this.list = [];
        }

        if (this.knowhowList.length) {
          this.list.push(...this.knowhowList);

          // 페이지 이동시 저장된 페이지 개수만큼 호출
          if (this.scrollLocation > 0) {
            setTimeout(() => {
              target.scrollTo(0, this.scrollLocation);
            }, 10);

            // 뒤로가기로 온 이후 페이지가 다 로딩이 되면 스크롤 저장 위치를 초기화
            setTimeout(() => {
              this.scrollLocation = 0;
            }, 1000);
          }

          this.params.page += 1;
          $state.loaded();
        } else {
          // 페이지 다 호출하면 저장된 위치로 이동
          $state.complete();
        }
      }
    },
  },
};
</script>

<style></style>
